import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import Utils from '../../utils/utils';
import {AccountService} from './account.service';

export const canAccess: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const accountService = inject(AccountService);

  if (localStorage.getItem('accessToken') === undefined || localStorage.getItem('accessToken') === null) {
    router.navigate(['login']);
    return false;
  }

  return accountService.identity().then((authenticated) => {
    if (authenticated) {
      return true;
    } else {
      Utils.cleanLocalStorage();
      router.navigate(['login']);
      return false;
    }
  });
};
